
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 10.628a.5.5 0 00.5-.5V7.635a1.5 1.5 0 00-1.5-1.5h-.523a.491.491 0 00.009-.258.5.5 0 00-.233-.3l-7.611-4.398a.5.5 0 00-.683.183l-2.188 3.79L9.782 3.6A1.509 1.509 0 008.7 3.138H1.5A1.5 1.5 0 000 4.639v15.973a.6.6 0 00.012.061.6.6 0 00.017.084.518.518 0 00.056.119c.01.015.012.033.023.047s.014.01.02.016a.485.485 0 00.115.092.491.491 0 00.05.034.5.5 0 00.207.047h21a.5.5 0 00.487-.385l2-8.487a.5.5 0 00-.487-.615h-4.668l2.594-4.492H22.5a.5.5 0 01.5.5v2.493a.5.5 0 00.5.502zm-22-6.49h7.2a.508.508 0 01.364.154l1.69 1.762L9.067 8.97a.5.5 0 00.183.683l3.415 1.972H2.5a.5.5 0 00-.487.385L1 16.31V4.639a.5.5 0 01.5-.501zm19.6 15.974H1.131L2.9 12.625h19.969zm-6.473-8.487a.517.517 0 00-.066-.058l-4.382-2.53L14.075 2.3l6.742 3.893-3.139 5.437z"}})])
          )
        }
      }
    